import './styles.scss';

import { useMemo } from 'react';

import { BacktesterStrategyData } from '../../../../../providers/backtesting/api/backtester-config-api.types';
import { METRICS } from '../../../../../providers/portfolio-performance/risk/risk.types';
import { buildRiskMetrics } from './build-risk-metrics';
import { BacktestRiskProvider } from './backtest-risk-provider';
import { BacktestRiskPanel } from './backtest-risk-panel';

interface MarketRiskProps {
  strategyData: BacktesterStrategyData;
  selectedStrategy: string;
}

// Greeks risk view for the open stratlet — the shared Portfolio Performance
// risk panel rendered over delta/theta/gamma/vega/pv straight from
// pnl_reports (reuse plan §3), via a thin BacktestRiskProvider.
export const MarketRisk = ({ strategyData, selectedStrategy }: MarketRiskProps) => {
  const scenario = strategyData[selectedStrategy];
  const metricsData = useMemo(() => buildRiskMetrics(scenario), [scenario]);
  const token = scenario?.stratlet.account.token?.trim() || 'BTC';
  const hasData = METRICS.some((metric) => (metricsData[metric]?.data?.length ?? 0) > 0);

  return (
    <div className="backtest-result-view backtest-result-market-risk">
      {hasData ? (
        <BacktestRiskProvider
          metricsData={metricsData}
          token={token}
          strategyName={selectedStrategy}
        >
          <BacktestRiskPanel />
        </BacktestRiskProvider>
      ) : (
        <div className="backtest-market-risk-placeholder">
          <span className="backtest-market-risk-placeholder-title">Greeks risk view</span>
          <span className="backtest-market-risk-placeholder-body">
            No risk snapshots for this stratlet.
          </span>
        </div>
      )}
    </div>
  );
};
